import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Screen } from '@core/interfaces';

import {
  AuthPermissionsResponseBody,
  AuthPingResponseBody,
  ChangeCustomerResponseBody,
  ChangeFacilityResponseBody,
  ChangeLanguageResponseBody,
  LoginResponseBody,
} from '#types/auth';

import { AuthState } from './auth.reducers';

export const Login = createAction('[Auth] - Login', props<{ username: string; password: string }>());
export const LoginSuccess = createAction('[Auth] - Login Success', props<{ payload: LoginResponseBody }>());
export const LoginFailure = createAction('[Auth] - Login Failure', props<{ error: HttpErrorResponse }>());

export const LoginFromBroadcast = createAction('[Auth] - Login From Broadcast', props<{ payload: AuthState; redirect: string }>());
export const LoginFromBroadcastSuccess = createAction('[Auth] - Login From Broadcast Success', props<{ redirect: string }>());

export const Logout = createAction('[Auth] - Logout');
export const LogoutSuccess = createAction('[Auth] - Logout Success');
export const LogoutFailure = createAction('[Auth] - Logout Failure', props<{ error: HttpErrorResponse }>());

export const Permissions = createAction('[Auth] - Permissions');
export const PermissionsSuccess = createAction('[Auth] - Permissions Success', props<{ payload: AuthPermissionsResponseBody }>());
export const PermissionsFailure = createAction('[Auth] - Permissions Failure', props<{ error: HttpErrorResponse }>());

export const SetApplicationEnvironment = createAction('[Auth] - Set Application Environment', props<{ environment: string }>());
export const SetAuthenticated = createAction('[Auth] - Set Authenticated', props<{ authenticated: boolean }>());

export const ChangeCustomer = createAction('[Auth] - Change Customer', props<{ custid: string }>());
export const ChangeCustomerSuccess = createAction('[Auth] - Change Customer Success', props<{ payload: ChangeCustomerResponseBody }>());
export const ChangeCustomerFailure = createAction('[Auth] - Change Customer Failure', props<{ error: HttpErrorResponse }>());

export const ChangeCustomerFromBroadcast = createAction(
  '[Auth] - Change Customer From Broadcast',
  props<{ payload: ChangeCustomerResponseBody }>()
);

export const ChangeFacility = createAction('[Auth] - Change Facility', props<{ facility: string }>());
export const ChangeFacilitySuccess = createAction('[Auth] - Change Facility Success', props<{ payload: ChangeFacilityResponseBody }>());
export const ChangeFacilityFailure = createAction('[Auth] - Change Facility Failure', props<{ error: HttpErrorResponse }>());

export const ChangeFacilityFromBroadcast = createAction(
  '[Auth] - Change Facility From Broadcast',
  props<{ payload: ChangeFacilityResponseBody }>()
);

export const ChangeLanguage = createAction('[Auth] - Change Language', props<{ language: string }>());
export const ChangeLanguageSuccess = createAction('[Auth] - Change Language Success', props<{ payload: ChangeLanguageResponseBody }>());
export const ChangeLanguageFailure = createAction('[Auth] - Change Language Failure', props<{ error: HttpErrorResponse }>());

export const ChangeLanguageFromBroadcast = createAction('[Auth] - Change Language From Broadcast', props<{ language: string }>());

export const ChangeScreen = createAction('[Auth] - Change Screen', props<{ screen: Screen }>());

export const ResetState = createAction('[Auth] - Reset State');

export const ChangeTheme = createAction('[Auth] - Change Theme', props<{ theme: string }>());
export const ChangeThemeSuccess = createAction('[Auth] - Change Theme Success', props<{ theme: string }>());
export const ChangeThemeFailure = createAction('[Auth] - Change Theme Failure', props<{ error: HttpErrorResponse }>());

export const ChangeThemeFromBroadcast = createAction('[Auth] - Change Theme From Broadcast', props<{ theme: string }>());

export const SetSessionId = createAction('[Auth] - Set Session ID', props<{ id: string }>());

export const SessionPing = createAction('[Auth] - Session Ping');
export const SessionPingSuccess = createAction('[Auth] - Session Ping Success', props<{ data: AuthPingResponseBody }>());
export const SessionPingFailure = createAction('[Auth] - Session Ping Failure', props<{ error: HttpErrorResponse }>());

export const SetSessionTimeout = createAction('[Auth] - Set Session Timeout', props<{ timeout: boolean }>());

export const LoginFromTimeout = createAction('[Auth] - Login From Timeout', props<{ username: string; password: string }>());
export const LoginFromTimeoutSuccess = createAction('[Auth] - Login From Timeout Success', props<{ payload: LoginResponseBody }>());
export const LoginFromTimeoutFailure = createAction('[Auth] - Login From Timeout Failure', props<{ error: HttpErrorResponse }>());
